import React, { useState } from 'react';
import './Pricing.css';

const Pricing = ({ addToCart }) => {
  const [selectedPlan, setSelectedPlan] = useState(2); // Professional pre-selected

  const pricingPlans = [
    {
      id: 1,
      name: "Starter",
      price: "₹10,000",
      period: "per year",
      description: "Perfect for small businesses just getting started",
      features: [
        "Unlimited transactions",
        "Basic inventory management",
        "Email support",
        "Single store",
        "Basic reports"
      ],
      popular: false,
    },
    {
      id: 2,
      name: "Professional",
      price: "₹15,000",
      period: "per year",
      description: "Ideal for growing businesses with multiple locations",
      features: [
        "Including Starter",
        "Advanced inventory management",
        "24/7 phone support",
        "Indun support",
        "Advanced analytics",
        "Customer loyalty program"
      ],
      popular: true, // Always most popular
    },
    {
      id: 3,
      name: "Enterprise",
      price: "₹20,000",
      period: "per year",
      description: "For large businesses with complex needs",
      features: [
        "Everything in Professional",
        "Custom hardware integration",
        "Dedicated account manager",
        "Multi store Indun support",
        "Common stock store support",
        "Custom development"
      ],
      popular: false,
    }
  ];

  const handleSelect = (plan) => {
    setSelectedPlan(plan.id); // only highlight
  };

  const handleGetStarted = (plan) => {
    addToCart(plan); // navigate
  };

  return (
    <section id="pricing" className="section pricing-section">
      <div className="container">
        <h2 className="section-title">Simple, Transparent Pricing</h2>
        <p className="section-subtitle">
          Choose the plan that works best for your business. All plans per year/per outlet include a 14-day free trial.
        </p>

        <div className="pricing-grid">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`pricing-card ${selectedPlan === plan.id ? 'selected' : ''}`}
              onClick={() => handleSelect(plan)} // highlight on card click
            >
              {/* Badge only on Professional */}
              {plan.popular && <div className="popular-badge">Most Popular</div>}

              <h3>{plan.name}</h3>
              <div className="price">
                <span className="amount">{plan.price}</span>
                <span className="period">{plan.period}</span>
              </div>
              <p className="plan-description">{plan.description}</p>

              <ul className="features-list">
                {plan.features.map((feature, idx) => (
                  <li key={idx}><i className="fas fa-check"></i> {feature}</li>
                ))}
              </ul>

                    <button
                    className={`btn btn-primary ${selectedPlan === plan.id ? 'active' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedPlan(plan.id);
                      handleGetStarted(plan);
                    }}
                  >
                    Get Started
                  </button>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
